<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <button @click="preordercustomerdetail">
            Load Customers and Products
          </button>
          <ul v-if="customers.length > 0">
            <li v-for="customer in customers">
              {{ customer.CUSTOMERNAME }} {{ customer.CUSTOMERID }} ----
              <ul>
                <!-- Loop through customer's products -->
                <li v-for="product in customerProducts">
                  <div v-if="product.CUSTOMERID === customer.CUSTOMERID">
                    {{ product.PRODUCTNAME }}
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      customers: [],
      customerProducts: [],
    };
  },
  methods: {
    preordercustomerdetail() {
      RestAPI.getPreorderCustomerDetail(134)
        .then((res) => {
          console.log("res.data: " + JSON.stringify(res.data));
          this.customers = res.data.customers;
          this.customerProducts = res.data.customerProducts;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
  },
};
</script>
